import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, ExternalLink } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer-main">
      <div className="container">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          {/* Company Info */}
          <div>
            <Link to="/" className="footer-logo-wrapper">
              <img 
                src="/pinnacle-logo.png" 
                alt="Pinnacle Biomed Logo" 
                className="footer-logo-image"
              />
            </Link>
            <p className="body-regular footer-text mt-4">
              Excellence in Healthcare Infrastructure. Turnkey solutions for Government, Private, and Trust Hospitals across India.
            </p>
            <a
              href="http://pinnaclebiomed.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 mt-4 px-4 py-2"
              style={{
                background: 'var(--brand-orange)',
                color: 'white',
                borderRadius: '4px',
                textDecoration: 'none',
                fontSize: '14px',
                fontWeight: '500',
                transition: 'all 0.3s ease'
              }}
            >
              Visit Main Website <ExternalLink size={14} />
            </a>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="heading-3 mb-4">Quick Links</h4>
            <ul className="space-y-3">
              <li><Link to="/" className="footer-link">Home</Link></li>
              <li><Link to="/about" className="footer-link">About</Link></li>
              <li><Link to="/products" className="footer-link">Products</Link></li>
              <li><Link to="/services" className="footer-link">Services</Link></li>
              <li><Link to="/project-types" className="footer-link">Project Types</Link></li>
              <li><Link to="/core-strengths" className="footer-link">Core Strengths</Link></li>
              <li><Link to="/compliance" className="footer-link">Compliance</Link></li>
              <li><Link to="/company-profile" className="footer-link footer-download-link">Download Company Profile</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="heading-3 mb-4">Our Services</h4>
            <ul className="space-y-3">
              <li className="body-regular footer-text">Design & Engineering</li>
              <li className="body-regular footer-text">EPC & Construction</li>
              <li className="body-regular footer-text">Medical Equipment & IT</li>
              <li className="body-regular footer-text">Hospital Operations</li>
              <li className="body-regular footer-text">Testing & Commissioning</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="heading-3 mb-4">Contact Us</h4>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <Mail size={18} style={{ color: 'var(--text-primary)', flexShrink: 0, marginTop: '2px' }} />
                <a href="mailto:info@pinnaclebiomed.in" className="footer-link">
                  info@pinnaclebiomed.in
                </a>
              </div>
              <div className="flex items-start gap-3">
                <Phone size={18} style={{ color: 'var(--text-primary)', flexShrink: 0, marginTop: '2px' }} />
                <a href="tel:+912245796459" className="footer-link">
                  +91 22 4579 6459
                </a>
              </div>
              <div className="flex items-start gap-3">
                <MapPin size={18} style={{ color: 'var(--text-primary)', flexShrink: 0, marginTop: '2px' }} />
                <p className="body-regular footer-text">
                  3A & 3B, 3rd Floor, Trust House,<br />
                  35 Hospital Avenue, Dr. E. Borges Road,<br />
                  Parel, Mumbai - 400012, India
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="footer-bottom">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="body-small footer-text-light">
              © {currentYear} Pinnacle Biomed India Pvt. Ltd. All rights reserved.
            </p>
            <p className="body-small footer-text-light text-center md:text-right">
              Committed to delivering safe, compliant, and sustainable healthcare infrastructure.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
